// extracted by mini-css-extract-plugin
export default {"footer":"index_footer_Fsqdp","footerBox":"index_footerBox_rrxtd","footerItem":"index_footerItem_CvecB","footerLink":"index_footerLink_N12Bc"};